<template>
  <div class="my-contract">
    <div class="title">我的合同</div>
    <div class="table">
      <div class="tr">
        <div class="th">
          合同ID
        </div>
        <div class="th">
          合同名称
        </div>
        <div class="th">
          订单号
        </div>
        <div class="th">
          合同状态
        </div>
        <div class="th">
          发起时间
        </div>
        <div class="th">
          操作
        </div>
      </div>
      <div class="tr" v-for="(item, index) in contractList" :key="index">
        <div class="td">
          {{ item.contract_no }}
        </div>
        <div class="td">
          {{ item.contract_name }}
        </div>
        <div class="td">
          {{ item.orders.order_no }}
        </div>
        <div class="td">
          <span
            :class="item.status == 1 ? 'green' : item.status == 2 ? 'red' : ''"
            >{{ item.status_text }}</span
          >
        </div>
        <div class="td">
          {{ item.orders.submit_time_text }}
        </div>
        <div class="td">
          <div @click="goDetail(item)">查看详情</div>
        </div>
      </div>
      <div class="page">
        <el-pagination layout="prev, pager, next"
        @current-change="pageChange" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import contractApi from '@/api/contract'
export default {
  data() {
    return {
      limit: 10,
      page: 1,
      total: 0,
      contractList: []
    };
  },
  created() {
    this.$emit("getCompontsIndex", 2);
    this.getContract();
  },
  methods: {
    async getContract() {
      let {data: orderList} = await contractApi.info.list({
          page : this.page,
          list_rows: this.limit
      })
      this.contractList = orderList.data || [];
      this.total = orderList.total || 0
    },
    goDetail(e) {
      this.$router.push({
        path: "/PerSonalLayout/ContractInfo/" + e.id
      });
    },
    pageChange(e){
      this.page=e
      this.getContract()
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/personal-info/my-contract.vue